export const DMS_MODULE = 'Oem';
